import { racehorse360 } from "@tsg/1st-grpc-web-rh360";
import { SortOrder } from "interfaces/SortOrder";

const base = "PREFERRED_CONDITIONS_PAGE";
export const SET_ORDER = `${base}_SET_ORDER`;
export const SET_ORDER_BY = `${base}_SET_ORDER_BY`;
export const SET_SEARCH_QUERY = `${base}_SET_SEARCH_QUERY`;
export const SET_TRAINER_SEARCH_ITEM = `${base}_SET_TRAINER_SEARCH_ITEM`;
export const SET_PREFERRED_VALUES = `${base}_SET_PREFERRED_VALUES`;
export const SET_PREFERRED_DISTANCE = `${base}_SET_PREFERRED_DISTANCE`;
export const SET_PREFERRED_SURFACE = `${base}_SET_PREFERRED_SURFACE`;
export const SET_PREFERRED_CONDITION = `${base}_SET_PREFERRED_CONDITION`;
export const SET_PREFERRED_AGE = `${base}_SET_PREFERRED_AGE`;
export const SET_PREFERRED_GENDER = `${base}_SET_PREFERRED_GENDER`;

export type ObjectWithStringKeys = {
  [key: string]: string | null;
};

export interface PreferredConditionsPageType {
  type: string;
  order: SortOrder;
  orderBy: string[];
  searchQuery: string;
  preferredDistance: string;
  preferredSurface: string;
  preferredCondition: string;
  preferredAge: string;
  preferredGender: string;
  preferredAllParams: ObjectWithStringKeys;
  trainerSearchItem: racehorse360.ITrainer;
  offsetNumber: number;
}

export const setOrder = (
  order: SortOrder
): Partial<PreferredConditionsPageType> => {
  return {
    type: SET_ORDER,
    order
  };
};

export const setOrderBy = (
  orderBy: string[]
): Partial<PreferredConditionsPageType> => {
  return {
    type: SET_ORDER_BY,
    orderBy
  };
};

export const setSearchQuery = (
  searchQuery: string
): Partial<PreferredConditionsPageType> => {
  return {
    type: SET_SEARCH_QUERY,
    searchQuery
  };
};

export const setPreferredDistance = (
  preferredDistance: string
): Partial<PreferredConditionsPageType> => {
  return {
    type: SET_PREFERRED_DISTANCE,
    preferredDistance
  };
};

export const setPreferredSurface = (
  preferredSurface: string
): Partial<PreferredConditionsPageType> => {
  return {
    type: SET_PREFERRED_SURFACE,
    preferredSurface
  };
};

export const setPreferredCondition = (
  preferredCondition: string
): Partial<PreferredConditionsPageType> => {
  return {
    type: SET_PREFERRED_CONDITION,
    preferredCondition
  };
};

export const setPreferredAge = (
  preferredAge: string
): Partial<PreferredConditionsPageType> => {
  return {
    type: SET_PREFERRED_AGE,
    preferredAge
  };
};

export const setPreferredGender = (
  preferredGender: string
): Partial<PreferredConditionsPageType> => {
  return {
    type: SET_PREFERRED_GENDER,
    preferredGender
  };
};

export const setPreferredValues = (
  preferredAllParams: ObjectWithStringKeys
): Partial<PreferredConditionsPageType> => {
  return {
    type: SET_PREFERRED_VALUES,
    preferredAllParams
  };
};

export const setTrainerSearchItem = (
  trainerSearchItem: racehorse360.ITrainer
): Partial<PreferredConditionsPageType> => {
  return {
    type: SET_TRAINER_SEARCH_ITEM,
    trainerSearchItem
  };
};
